﻿<script setup>
import {ref, defineProps, defineModel, watch, computed} from "vue";
import axios from "axios";
import {debounce} from "lodash";
import ReferralFormLabel from "@/components/ReferralFormLabel.vue";

const selected = defineModel(); 
const placeId = defineModel("placeId");

const props = defineProps({
  required: {
    type: Boolean,
    default: false
  },
  label: {
    type: String,
    default: "Address"
  }
})

const suggestions = ref([])
const isSearching = ref(false);
const search = ref("");
const placeIdsByLabel = new Map();
const addressRules = computed(() => props.required
    ? [value => (!!value && !!placeId.value) || "Select an address from the suggestions"]
    : []);

watch(selected, value => {
  if (!value) {
    placeId.value = undefined;
    return;
  }

  const selectedPlaceId = placeIdsByLabel.get(value);
  if (selectedPlaceId) placeId.value = selectedPlaceId;
});

const searchPlaces = debounce(async () => {
  suggestions.value = [];
  if (!search.value) return;
  isSearching.value = true;
  const response = await axios.post('https://places.googleapis.com/v1/places:autocomplete', {
    input: search.value,
    includedRegionCodes: ['au'],
    origin: { latitude: -33.745, longitude: 150.689 },
    regionCode: 'au',
  }, {
    headers: {
      'X-Goog-Api-Key': "AIzaSyAeqJpQF9NbA7x1FuglxObQ7BKZC-rWbxE"
    }
  })
  suggestions.value = response.data.suggestions.map(x => {
    const label = x.placePrediction.text.text;
    placeIdsByLabel.set(label, x.placePrediction.placeId);
    return label;
  });
  isSearching.value = false;
}, 250)



</script>

<template>

  <ReferralFormLabel required>{{ label }}</ReferralFormLabel>
  <v-autocomplete
      autocomplete="off"
      v-model="selected"
      v-model:search="search"
      :required="required"
      :rules="addressRules"
      :loading="isSearching"
      :items="suggestions"
      @input="searchPlaces">
    
    <template #no-data>
      <v-list-item>
        Start typing to search address...
      </v-list-item>
    </template>
    
  </v-autocomplete>
</template>

<style scoped>

</style>
